export const PARTNER_RECOMMEND_MARKER = 'Recommended by your lifestyle manager';

export function buildPartnerRecommendationDescription({
  price,
  currency = 'USD',
  notes = '',
  managerLabel = PARTNER_RECOMMEND_MARKER,
} = {}) {
  const lines = [managerLabel];
  const amount = Number(price);
  if (Number.isFinite(amount) && amount > 0) {
    lines.push(`Price: ${currency || 'USD'} ${amount.toFixed(2)}`);
  }
  const trimmedNotes = String(notes || '').trim();
  if (trimmedNotes) {
    lines.push('');
    lines.push(trimmedNotes);
  }
  return lines.join('\n');
}

export function parsePartnerRecommendationMeta(description = '') {
  const text = String(description || '');
  const isPartnerRecommend = /recommended by your lifestyle manager/i.test(text);
  const priceMatch = text.match(/Price:\s*([A-Z]{3})\s*([0-9]+(?:\.[0-9]+)?)/i);
  return {
    isPartnerRecommend,
    cost_currency: priceMatch ? priceMatch[1].toUpperCase() : null,
    cost: priceMatch ? Number(priceMatch[2]) : null,
  };
}

const dateStamp = (value) => {
  const day = String(value || '').slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : '';
};

/** Where each partner shortcut goes. These are trip actions, not one shared AI prompt. */
export function partnerChipAction(id, { trip, location = '' } = {}) {
  const day = dateStamp(trip?.start_date);
  const at = (start, end) => (day ? { start_datetime: `${day}T${start}`, end_datetime: `${day}T${end}` } : {});
  switch (id) {
    case 'dinner':
      return {
        type: 'itinerary',
        activity: { name: 'Dinner', category: 'restaurant', location, ...at('19:00', '21:00') },
      };
    case 'yacht':
      return { type: 'inventory', query: 'yacht' };
    case 'inventory':
      return { type: 'inventory', query: '' };
    case 'rework':
      return {
        type: 'itinerary',
        activity: {
          name: 'Indoor alternative',
          category: 'activity',
          location,
          description: 'Weather backup for this day.',
          ...at('10:00', '16:00'),
        },
      };
    case 'message':
      return {
        type: 'message',
        path: trip?.inquiry_id ? `/partner/inquiries/${trip.inquiry_id}` : '/partner/inquiries',
      };
    case 'gaps':
      return {
        type: 'itinerary',
        activity: { name: '', category: 'other', location, ...at('09:00', '12:00') },
      };
    default:
      return null;
  }
}

export const PARTNER_AI_CONTEXT_CHIPS = [
  {
    id: 'dinner',
    prompt: 'Suggest dinner tonight near the trip destination. Prefer top-tier restaurants that fit the client spend level. Give 3 options with vibe and booking tip.',
  },
  {
    id: 'yacht',
    prompt: 'Find a yacht charter option for tomorrow that fits this trip destination and traveler count. Include duration, approximate price band, and what to confirm with the supplier.',
  },
  {
    id: 'inventory',
    prompt: 'Suggest 2–3 upsell add-ons from a luxury lifestyle inventory (car, yacht, villa, experience, restaurant, or event access) that fit this trip destination and dates. For each, give a short pitch and a suggested price band the partner can load into inventory.',
  },
  {
    id: 'rework',
    prompt: 'Rework one day of this itinerary assuming rain or poor outdoor weather. Keep the day productive and luxurious; suggest indoor or covered alternatives.',
  },
  {
    id: 'message',
    prompt: 'Draft a short, polished client-facing message summarizing what is planned next and any decisions needed. Do not invent bookings that are not on the itinerary.',
  },
  {
    id: 'gaps',
    prompt: 'Find gaps in this itinerary: empty mornings/afternoons, missing meals, or long idle stretches. Propose concrete fills that match the trip tone.',
  },
];
